import { createSelector } from 'reselect';
import { selectedTeamSelector } from './ui-state';
import { pmIntegrationSelector } from './sensors-authorizations';
import _ from 'lodash';
import { extractSelectedEntitiesFromFilter } from 'common/services/pm.service';
import { teamsByIdSelector, teamsSelector } from './teams';

const getProjects = state => state.projects;

export const allProjectsSelector = createSelector(
  [getProjects],
  projects => projects
);

export const teamsProjectsByIdSelector = createSelector(
  [allProjectsSelector],
  (teamsProjects = []) => _.keyBy(teamsProjects, 'id')
);

export const projectsByPdtIdSelector = createSelector(
  [allProjectsSelector],
  (teamsProjects = []) => _.keyBy(teamsProjects, 'pdt_project_id')
);

export const teamsProjectsByTeamIdSelector = createSelector(
  [teamsProjectsByIdSelector, teamsSelector],
  (projectsById = {}, teams) => {
    return teams.reduce((acc, team) => {
      const teamId = team?.id;
      const teamProjectId = team.project_id;
      const teamProject = projectsById[teamProjectId];

      return {
        ...acc,
        ...(teamProject && { [teamId]: teamProject })
      };
    }, {});
  }
);

/* Selectors refer to the global selected team */

export const selectedTeamProject = createSelector(
  [getProjects, selectedTeamSelector],
  (projects, selectedTeam) => {
    return selectedTeam
      ? projects.find(({ id }) => id === selectedTeam.project_id)
      : null;
  }
);

// currently returning list of Entities: board(Jira)/projects+teams(CH)
const selectedTeamEntities = createSelector(
  [selectedTeamProject, pmIntegrationSelector],
  (selectedTeamContainers, pmIntegration) => {
    const sensor_id = _.get(pmIntegration, 'sensor_id');
    if (selectedTeamContainers && sensor_id) {
      const selectedTeamFilter = _.get(selectedTeamContainers, 'filter');
      const selectedEntities =
        extractSelectedEntitiesFromFilter[sensor_id](selectedTeamFilter);
      return selectedEntities;
    }
    return [];
  }
);

export const selectedTeamContainerIds = createSelector(
  [selectedTeamEntities],
  selectedTeamEntities => {
    const selectedTeamProviderIds = _.map(
      selectedTeamEntities,
      ({ provider_id }) => provider_id
    );
    return selectedTeamProviderIds;
  }
);

/* Selectors refer to any team by id */

export const teamProjectSelector = createSelector(
  [teamsProjectsByIdSelector, teamsByIdSelector, (_, teamId) => teamId],
  (projectsById, teamsById, teamId) => {
    const team = teamsById[teamId];
    if (!team) return null;

    return projectsById[team.project_id] ?? null;
  }
);

const teamEntitiesSelector = createSelector(
  [teamProjectSelector, pmIntegrationSelector, (_, teamId) => teamId],
  (project, pmIntegration, teamId) => {
    const sensor_id = _.get(pmIntegration, 'sensor_id');
    if (project && sensor_id) {
      const teamFilter = _.get(project, 'filter');
      const entities = extractSelectedEntitiesFromFilter[sensor_id](teamFilter);
      return entities;
    }
    return [];
  }
);

export const teamPmEntitiesIdsSelector = createSelector(
  [teamEntitiesSelector, (_, teamId) => teamId],
  (entities, teamId) => {
    return entities.map(({ provider_id }) => provider_id);
  }
);
